import { render, staticRenderFns } from "./SeparationElement.vue?vue&type=template&id=bcd315a2&scoped=true"
import script from "./SeparationElement.vue?vue&type=script&lang=js"
export * from "./SeparationElement.vue?vue&type=script&lang=js"
import style0 from "./SeparationElement.vue?vue&type=style&index=0&id=bcd315a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd315a2",
  null
  
)

export default component.exports